// These color tokens don't exist in StormUI
export const squidInk = 'rgba(35, 47, 62, 1)'; // Global header background color
export const orange = 'rgba(255, 98, 0, 1)'; // Sidenav active category color
